import ModalWrapper from 'components/ModalWrapper'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { useHistory } from 'react-router-dom'
import './styles.scss'

const ModalPlan = ({ isOpen, toggle, message }) => {
  const history = useHistory()

  return (
    <ModalWrapper
      id='modalPlan'
      body={
        <div dangerouslySetInnerHTML={{ __html: message || I18n.t('modal_plan_description') }} />
      }
      isOpen={isOpen}
      toggle={toggle}
      showClose={true}
      eventBtn={()=>history.push('/dashboard/management/plan/edit')}
      eventBtnTxt={I18n.t('buttons_change_plan')}
      cancelBtn={toggle}
      cancelBtnTxt={I18n.t('dashboard_cancel')}
    />
  )
}

export default ModalPlan
